'use client';

import { c as _c } from "react/compiler-runtime";
import Text from '@/app/cc/_component/ui/common/Text/Text';
import RiskCard from '@/app/cc/_component/ui/section/RiskDiagnosis/RiskCard';
import styles from '@/app/cc/_component/ui/section/RiskDiagnosis/RiskDiagnosis.module.scss';
import { useGetDealType } from '@/app/cc/_stores/useDealTypeStore';
const RISKS_RENT = [{
  info: '사례 01',
  title: '집주인 변경',
  description1: '20대 대학생 박지훈씨 (가명)',
  description2: '지방에서 서울로 올라와​ 처음으로 혼자 집을 구하게 됐습니다.\n계약 당일, 집주인이라고 소개받은 사람과 전세 계약을 진행했지만,​ 확인해 보니 그 사람은​ 진짜 임대인이 아니었습니다.',
  description3: '내 보증금, 괜찮은 걸까요..?',
  icon: '😩',
  image: {
    src: '/cc/image/risk/risk_content_rent_1.svg',
    alt: '집주인 변경'
  }
}, {
  info: '사례 02',
  title: '몰래 대출',
  description1: '30대 직장인 이준호씨 (가명)',
  description2: '월세 생활을 끝내고​ 첫 전세 계약을 진행했습니다.\n 잔금 직전 확인해보니 집주인이 대출을 받은 걸 알게 되었습니다. \n\n집주인은 문제 없다고 하지만..',
  description3: '이 상태로 잔금 치뤄도 괜찮은 걸까요..?',
  icon: '😞',
  image: {
    src: '/cc/image/risk/risk_content_rent_2.svg',
    alt: '몰래 대출'
  }
}, {
  info: '사례 03',
  title: '이중 계약',
  description1: '50대 주부 김미숙씨 (가명)',
  description2: '남편의 지방 발령으로 이사를 하게 되었습니다.\n계약까지 했는데, 같은 집에 다른 세입자도 계약이 진행된 사실을 알게 됐습니다.\n\n 집주인은 연락이 안되고..',
  description3: '내 보증금, 돌려받을 수 있을까요..?',
  icon: '😮‍💨',
  image: {
    src: '/cc/image/risk/risk_content_rent_3.svg',
    alt: '이중 계약'
  }
}];
const RISKS_SALE = [{
  info: '사례 01',
  title: '이중계약',
  description1: '30대 직장인 이준호씨 (가명)',
  description2: '전세 생활을 끝내고 첫 내 집 마련에 나섰습니다.\n마음에 드는 집을 계약했지만,\n 며칠 뒤 같은 집이 다른 사람과도 계약된 사실을 알게 됐습니다',
  description3: '내 계약금, 돌려받을 수 있을까요?',
  icon: '😓',
  image: {
    src: '/cc/image/risk/risk_content_sale_1.svg',
    alt: '이중 계약'
  }
}, {
  info: '사례 02',
  title: '가짜 집주인',
  description1: '40대 직장인 김성주씨(가명)',
  description2: '아이들을 위해 더 넓은 집으로 이사를\n하게 되었습니다.\n집주인이라 믿고 계약금까지 지급했지만, 확인해보니 실제 소유자가 아니었습니다.',
  description3: '이 계약, 처음부터 잘못된 걸까요?',
  icon: '🫤',
  image: {
    src: '/cc/image/risk/risk_content_sale_2.svg',
    alt: '가짜 집주인'
  }
}, {
  info: '사례 03',
  title: '몰래 대출',
  description1: '50대 자영업 최진수씨(가명)',
  description2: '사업장 이전을 하면서 집 장만을 결심했습니다.\n계약 후, 잔금만 남은 상황이었는데 잔금 치르기 직전, 집주인이 대출을 받은 걸 알게 되었습니다.\n집주인은 문제없다고 하지만...',
  description3: '이 집, 정말 안전한 걸까요?',
  icon: '😢',
  image: {
    src: '/cc/image/risk/risk_content_sale_3.svg',
    alt: '몰래 대출'
  }
}];
export default function RiskDiagnosis() {
  const $ = _c(9);
  const dealType = useGetDealType();
  let t0;
  if ($[0] !== dealType) {
    t0 = <div className={styles.riskContent}>{dealType === "rent" ? <><div><Text as="h3" category="display" variant="eb2" color="var(--color-gray-900)">내 전세 보증금,<br className="break" /> 안전할까요?</Text></div><Text as="p" category="body" variant="r1" color="var(--color-gray-700)">보증금을 잃은 사람들 대부분은 <br className="break" />계약 당시 문제를 알지 못했습니다.<br />한 번의 계약 실수가{" "}<b>보증금을 돌려받지<br className="break" /> 못하는 결과</b>로 이어질 수 있습니다.</Text></> : <><div><Text as="h3" category="display" variant="eb2" color="var(--color-gray-900)">내 집 마련, 계약으로 <br className="break" /> 끝났다고 생각하셨나요?</Text></div><Text as="p" category="body" variant="r1" color="var(--color-gray-700)">부동산 사고를 겪은 매수인 대부분은<br className="break" /> 계약 당시 문제를 알지 못했습니다.<br />괜찮을 거라는 생각이 <b>되돌릴 수 없는 결과가 됩니다</b></Text></>}</div>;
    $[0] = dealType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== dealType) {
    t1 = dealType === "rent" ? RISKS_RENT.map(_temp) : RISKS_SALE.map(_temp2);
    $[2] = dealType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className={styles.riskCards}><div className={styles.riskCardsList}>{t1}</div></div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t2) {
    t3 = <section className={styles.riskDiagnosis}><div className={styles.inner}>{t0}{t2}</div></section>;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp2(risk_0) {
  return <RiskCard key={risk_0.title} {...risk_0} />;
}
function _temp(risk) {
  return <RiskCard key={risk.title} {...risk} />;
}